define(function(require) {
    var DomUtil = require("cartovista").DomUtil;
    return {
        ID: "Provincial_3",
        THEMESETS_IDS: ["Provincial_3"],
        SOURCE: '<span style="margin-top:15px; float:right; font-size:10px;">Source : MEQ, SIP, DGPP, DGVI, DIS, Taux de diplomation et qualification par cohorte au secondaire - édition 2026.</span>',
        TOP_PANEL: {
            PRINT_OPTIONS: {"landscape": false, "scale": 0.8},
            DEFAULTS: {
                GRAPH_TYPE: "bar",
                GRAPH_DATA_ORIENTATION: "columns",
                PADDING: {"left": 25, "top": 15, "right": 5, "bottom": 40},
                HEIGHT_FN: function() { 
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 60;
                    else return 315;
                },
                WIDTH_FN: function() { 
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() /3 - 150;
                    else return $("#BbGraphs_topPanel_container").width() - 20;
                },
                X_AXIS_TYPE: "category",
                X_DATA_NAMES: ["Diplômes", "Qualifications"],
                Y_AXIS_MIN_VALUE: 30,
                Y_AXIS_MAX_VALUE: 100,
                Y_AXIS_PADDING: 0,
                Y_AXIS_LABEL: "pt. de %",
                Y_GRID: true,
                STACK_ORDER: "asc",
                STACK_GROUPS: [["Diplômes", "Qualifications"]],
                DATA_COLORS: {"FGJ": "#a68adb", "FGA": "#85aec9", "FP": "#afbd54",  "Diplômes": "#6194BF", "Qualifications": "#B9EAD8"}
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + " pts. de %";}
            },
            SLIDES: [
                {
                    TITLE: "Contribution des diplômes et des qualifications  dans le taux de diplomation et qualification par cohorte au secondaire, cohorte de {{TEXT}}",
                    SUBTILE: null,
                    GRAPHS: [
                        {
                            TITLE: "Après 5 ans, sexes réunis",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_T_DIPL_{{VALUE}}", "TX_5_T_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 5 ans, sexe masculin",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_M_DIPL_{{VALUE}}", "TX_5_M_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 5 ans, sexe féminin",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_F_DIPL_{{VALUE}}", "TX_5_F_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 7 ans, sexes réunis",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_7_T_DIPL_{{VALUE}}", "TX_7_T_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 7 ans, sexe masculin",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_7_M_DIPL_{{VALUE}}", "TX_7_M_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 7 ans, sexe féminin",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_7_F_DIPL_{{VALUE}}", "TX_7_F_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };
});
